/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Checkbox, Table, Alert,
} from 'antd';
import WhatsappIntegrationActions from '@Actions/integrations/whatsappIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

/**
 *
 */
const EnableConfigurations = ({
  user, setStep, updateWhatsappConfiguration, updateWhatsappConfigurationLoading, getWhatsappConnections, getWhatsappConnectionsLoading,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getWhatsappConnections(user?.tenant_info?.org_id, (config) => {
      const orgConfiguration = config?.org_configuration;
      const mainData = [
        {
          entity: 'po',
          entityName: 'Purchase Order',
          is_po_notification_enabled: orgConfiguration?.is_po_notification_enabled,
          is_po_automatic_notification_enabled: orgConfiguration?.is_po_automatic_notification_enabled,
        },
        {
          entity: 'so',
          entityName: 'Sales Order',
          is_so_notification_enabled: orgConfiguration?.is_so_notification_enabled,
          is_so_automatic_notification_enabled: orgConfiguration?.is_so_automatic_notification_enabled,
        },
        {
          entity: 'inv',
          entityName: 'Invoice',
          is_inv_notification_enabled: orgConfiguration?.is_inv_notification_enabled,
          is_inv_automatic_notification_enabled: orgConfiguration?.is_inv_automatic_notification_enabled,
        },
        {
          entity: 'poa',
          entityName: 'Purchase Order Approval',
          is_purchase_order_approval_enabled: orgConfiguration?.is_purchase_order_approval_enabled,
        },
        {
          entity: 'sta',
          entityName: 'Stock Transfer Approval',
          is_stock_transfer_approval_enabled: orgConfiguration?.is_stock_transfer_approval_enabled,
        },
        {
          entity: 'pra',
          entityName: 'Material Request Approval',
          is_purchase_requisition_approval_enabled: orgConfiguration?.is_purchase_requisition_approval_enabled,
        },
      ];
      setData(mainData);
    });
  }, []);

  const checkDisabled = (record) => {
    if (record?.entity === 'po') {
      return record?.is_po_notification_enabled;
    }
    if (record?.entity === 'so') {
      return record?.is_so_notification_enabled;
    }
    if (record?.entity === 'inv') {
      return record?.is_inv_notification_enabled;
    }
  };

  const columns = [
    {
      title: 'NOTIFICATION TYPE',
      render: (record) => record?.entityName,
    },
    {
      title: 'ENABLED',
      render: (record) => {
        let enabled = true;
        if (record?.entity === 'po') {
          enabled = record?.is_po_notification_enabled;
        }
        if (record?.entity === 'so') {
          enabled = record?.is_so_notification_enabled;
        }
        if (record?.entity === 'inv') {
          enabled = record?.is_inv_notification_enabled;
        }
        if (record?.entity === 'poa') {
          enabled = record?.is_purchase_order_approval_enabled;
        }
        if (record?.entity === 'sta') {
          enabled = record?.is_stock_transfer_approval_enabled;
        }
        if (record?.entity === 'pra') {
          enabled = record?.is_purchase_requisition_approval_enabled;
        }
        return (
          <div>
            <Checkbox
              checked={enabled}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(data));
                const updatedData = copyData.map((obj) => {
                  if (obj.entity === record.entity) {
                    if (record?.entity === 'po') {
                      return {
                        ...obj,
                        is_po_notification_enabled: event.target.checked,
                        is_po_automatic_notification_enabled: event.target.checked,
                      };
                    }
                    if (record?.entity === 'so') {
                      return {
                        ...obj,
                        is_so_notification_enabled: event.target.checked,
                        is_so_automatic_notification_enabled: event.target.checked,
                      };
                    }
                    if (record?.entity === 'inv') {
                      return {
                        ...obj,
                        is_inv_notification_enabled: event.target.checked,
                        is_inv_automatic_notification_enabled: event.target.checked,
                      };
                    }
                    if (record?.entity === 'poa') {
                      return { ...obj, is_purchase_order_approval_enabled: event.target.checked };
                    }
                    if (record?.entity === 'sta') {
                      return { ...obj, is_stock_transfer_approval_enabled: event.target.checked };
                    }
                    if (record?.entity === 'pra') {
                      return { ...obj, is_purchase_requisition_approval_enabled: event.target.checked };
                    }
                  }
                  return obj;
                });
                setData(updatedData);
              }}
            />
          </div>
        );
      },
    },
    {
      title: 'SEND AUTOMATIC NOTIFCATION',
      render: (record) => {
        let enabled = true;
        if (record?.entity === 'po') {
          enabled = record?.is_po_automatic_notification_enabled;
        }
        if (record?.entity === 'so') {
          enabled = record?.is_so_automatic_notification_enabled;
        }
        if (record?.entity === 'inv') {
          enabled = record?.is_inv_automatic_notification_enabled;
        }
        return (['po', 'so', 'inv'].includes(record?.entity) && (
          <div>
            <Checkbox
              checked={enabled}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(data));
                const updatedData = copyData.map((obj) => {
                  if (obj.entity === record.entity) {
                    if (record?.entity === 'po') {
                      return { ...obj, is_po_automatic_notification_enabled: event.target.checked };
                    }
                    if (record?.entity === 'so') {
                      return { ...obj, is_so_automatic_notification_enabled: event.target.checked };
                    }
                    if (record?.entity === 'inv') {
                      return { ...obj, is_inv_automatic_notification_enabled: event.target.checked };
                    }
                  }
                  return obj;
                });
                setData(updatedData);
              }}
              disabled={!checkDisabled(record)}
            />
          </div>
        ));
      },
    },
  ];

  const handleSubmit = () => {
    const configuration = data.reduce((result, item) => {
      const { entity, entityName, ...rest } = item;
      Object.assign(result, rest);
      return result;
    }, {});

    const payload = [{
      org_id: user?.tenant_info?.org_id,
      ...configuration,
    }];

    updateWhatsappConfiguration(payload, () => {
      setStep(2);
    });
  };

  return (
    <Fragment>
      {(getWhatsappConnectionsLoading)
        ? (
          <div className="tally-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="tally-integration__loader-row">
                <div className="loadingBlock  tally-integration__loader__line1" />
                <div className="loadingBlock  tally-integration__loader__line2" />
                <div className="loadingBlock  tally-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock tally-integration__loader__line-btn1" />
            <div className="loadingBlock tally-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="whatsapp__enable-config-wrapper">
            <div className="whatsapp__enable-config-header-wrapper">
              Select notifications to be enabled
            </div>
            <div className="whatsapp__enable-config-body-wrapper">
              <div className="whatsapp__enable-config__entity-table-wrapper">
                <div className="ant-row">
                  <div className="ant-col-md-16">
                    <Table
                      columns={columns}
                      dataSource={data}
                      pagination={false}
                      loading={updateWhatsappConfigurationLoading}
                      size="small"
                    />
                  </div>
                  <div className="ant-col-md-16" />
                  <div className="ant-col-md-16" style={{ marginTop: '15px' }}>
                    <Alert
                      showIcon
                      message={(
                        <div>
                          Automatic notifications are only triggered when the document status is ISSUED or CONFIRMED.
                        </div>
                      )}
                      type="info"
                      style={{ borderRadius: '4px' }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="whatsapp__enable-config-footer-wrapper">
              <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
                {/* <H3Button
                  text="Back"
                  buttonType={defaultButtonTypes.BLUE_BORDERED}
                  onClick={() => setStep(1)}
                  customClass="whatsapp__action-button"
                  disabled={updateWhatsappConfigurationLoading}
                /> */}
                <div>
                  <H3Button
                    text="Save and Continue"
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    onClick={() => handleSubmit()}
                    customClass="whatsapp__account-submit"
                    isLoading={updateWhatsappConfigurationLoading || getWhatsappConnectionsLoading}
                    disabled={updateWhatsappConfigurationLoading || getWhatsappConnectionsLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, WhatsappIntegrationReducers }) => ({
  user: UserReducers.user,
  getWhatsappConnectionsLoading: WhatsappIntegrationReducers.getWhatsappConnectionsLoading,
  updateWhatsappConfigurationLoading: WhatsappIntegrationReducers.updateWhatsappConfigurationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateWhatsappConfiguration: (payload, callback) => dispatch(WhatsappIntegrationActions.updateWhatsappConfiguration(payload, callback)),
  getWhatsappConnections: (orgId, callback) => dispatch(WhatsappIntegrationActions.getWhatsappConnections(orgId, callback)),
});

EnableConfigurations.propTypes = {
  user: PropTypes.any,
  setStep: PropTypes.func,
  updateWhatsappConfiguration: PropTypes.func,
  getWhatsappConnections: PropTypes.any,
  getWhatsappConnectionsLoading: PropTypes.bool,
  updateWhatsappConfigurationLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EnableConfigurations));
